import { jsx } from "react/jsx-runtime";
const Linkedin = ({ className, color = '#181B32', size = 32, ignoreColor })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: 0.9375 * size,
        height: size,
        viewBox: "0 0 30 32",
        children: /*#__PURE__*/ jsx("path", {
            fill: ignoreColor ? void 0 : color,
            d: "M15.858 14.434v-.05l-.03.05h.03zM27.31.001H2.179C.976.001 0 1.028 0 2.294v27.412C0 30.972.976 32 2.179 32h25.13c1.204 0 2.18-1.028 2.18-2.294V2.294c0-1.267-.976-2.293-2.18-2.293zM8.939 26.787H4.485V12.338h4.454v14.449zM6.712 10.366h-.03c-1.494 0-2.461-1.11-2.461-2.497 0-1.417.997-2.496 2.52-2.496s2.462 1.079 2.491 2.496c0 1.387-.967 2.497-2.52 2.497zm18.287 16.421h-4.453v-7.731c0-1.942-.644-3.266-2.256-3.266-1.23 0-1.963.893-2.286 1.756-.118.309-.146.739-.146 1.172v8.069h-4.454s.058-13.093 0-14.449h4.454v2.046c.592-.984 1.651-2.385 4.015-2.385 2.93 0 5.127 2.065 5.127 6.504v8.285z"
        })
    });
const src_Linkedin = Linkedin;
export default src_Linkedin;
